<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0 pb-4" cols="12">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">{{ $trans('saleorders') }}</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4">
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-switch
                                label="Attiva impostazione automatica dello stato degli ordini di vendita in base alle quantità evase"
                                v-model="settings['enable_status_check']"
                                color="primary"
                                dense
                                inset
                                hide-details
                                class="margin-auto"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
		<v-col class="pa-0" cols="12">
			<numbering-check-settings
				model-name="saleorder"
				document-label="gli ordini di vendita"
			/>
		</v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

	export default {
		name: 'orders-other',
		components: {
			NumberingCheckSettings
		},
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'saleorder',
				settings: {
					'enable_status_check': false
				}
			}
		}
	}
</script>